import React from 'react';
import MembershipDemo from 'Pages/userManagement/MembershipDemo';
import { V2SettingsShell } from '../../_shared/V2SettingsShell';

// Settings → Affiliate Program (v2). The membership module is self-contained
// (own CSS module, light card theme), so the v2 layer only supplies the shell
// chrome — heading, sidebar, dock — around it.
export const AffiliateSettingsV2 = () => (
  <V2SettingsShell
    title="Affiliate Program"
    description="Your membership, the accounts you've created, and member pricing."
  >
    <MembershipDemo />
  </V2SettingsShell>
);

export default AffiliateSettingsV2;
